import React from "react";
import {useI18next, useTranslation} from "gatsby-plugin-react-i18next";

import {isRtlLanguage} from "../utils/rtl";

const RecommenderCode = ({coupon, loading}) => {
	const {t} = useTranslation();
	const {language} = useI18next();
	const isRtl = isRtlLanguage(language);

	return (
		<div>
			<span dangerouslySetInnerHTML={{__html: t("recommender_coupon")}} />
			<span className={`${isRtl ? "mr-2" : "ml-2"} inline-flex items-center min-w-[140px]`}>
				{loading && <span className="h-4 w-4 spinner" data-testid="recommender-coupon-loading" />}
				{!loading && coupon && (
					<span className="font-semibold leading-5" data-testid="recommender-coupon-value">
						{coupon}
					</span>
				)}
				{!loading && !coupon && (
					<span className="italic leading-5" data-testid="recommender-coupon-empty">
						{t("no_active_recommender_code")}
					</span>
				)}
			</span>
		</div>
	);
};

export default RecommenderCode;
